import React from 'react';
import { useEffect, useRef, useState } from "react";
import { getOcrdataLicConducirAutoTrans } from '../../api/getOcrdataLicConducirAutoTrans';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';

function Pantalla8Lic() {

    const isRunned = useRef(false);
    const [firstName, setFirstName] = useState('');
    const [paternalLastName, setPaternalLastName] = useState('');
    const [maternalLastName, setMaternalLastName] = useState('');
    const [typeClass, setTypeClass] = useState('');
    const [issuingAuthority, setIssuingAuthority] = useState('');
    const [issuingAuthorityISO, setIssuingAuthorityISO] = useState('');
    const [expireAtStr, setExpireAtStr] = useState('');
    const [numberLicStr, setNumberLicStr] = useState('');
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState('');
    const navigate = useNavigate();

    const handleClose = () => {
        setShow(false);
        navigate('/PantallaBase3Lic');
    }

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            setLoading(true);

            /**
             * Agregar comparacion de incode con los valores escritos por el usuario 
             */

            const objIncode = {
                interviewId: localStorage.getItem("interviewIdLic"),
                tokenIncode: localStorage.getItem("tokenIncodeLic"),
                licenseNumber: localStorage.getItem("numeroLicencia"),
                nombre: localStorage.getItem("nombre"),
                paterno: localStorage.getItem("paterno"),
                materno: localStorage.getItem("materno"),
            }

            const response = await getOcrdataLicConducirAutoTrans(objIncode);

            if (response.status === 200) {

                localStorage.setItem("typeClass", "" + response.classes);
                
                setFirstName(localStorage.getItem("nombre"));
                setPaternalLastName(localStorage.getItem("paterno"));
                setMaternalLastName(localStorage.getItem("materno"));

                setNumberLicStr(localStorage.getItem("numeroLicencia"));
                localStorage.setItem("similarity", "" + response.similarity);

                /* Valores que regresa Incode*/
                //setNumberLicStr(response.cic);
                //setTypeClass(response.classes);
                //setIssuingAuthority(response.issuingAuthority);

                setTypeClass(localStorage.getItem("tipoLicencia"));
                setIssuingAuthority(localStorage.getItem("emisor"));
                setIssuingAuthorityISO(localStorage.getItem("emisorISO"));
                //setExpireAtStr(response.expireAtStr);
                setExpireAtStr(localStorage.getItem("vigencia"));
                setLoading(false);

            } else {
                setLoading(false);
                setShow(true);
                setShowStatus(response.status);
                setShowMessage(response.message);
            }

            setLoading(false);
        }

        createSession();

    }, []);

    return (
        <>
            <div className="containerRender">
                {loading ? (
                    <div className="spinner"></div>
                ) : (
                    <div className='containerInfo_P2'>
                        <div className="containerIdent_P2">
                            <div className='txtOp_P2'>Nombres/Given names</div>
                            <div className='txtVer_P2'>{firstName}</div>
                            <div className='txtCpv_P2'>Apellidos/Surname</div>
                            <div className='txtVer_P2'>{paternalLastName} {maternalLastName}</div>
                            <div className='txtCpv_P2'>Número/Number</div>
                            <div className='txtVer_P2'>{numberLicStr}</div>
                            <div className='txtCpv_P2'>Tipo/Class</div>
                            <div className='txtVer_P2'>{typeClass}</div>
                            <div className='txtCpv_P2'>Emisor/Issuer</div>
                            <div className='txtVer_P2'>{issuingAuthorityISO} {issuingAuthority}</div>
                            <div className='txtCpv_P2'>Vigencia/Expiration</div>
                            <div className='txtVer_P2'>{expireAtStr}</div>
                        </div>
                    </div>
                )}
            </div>

            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default Pantalla8Lic
